import { baseUrl } from '../http'
import axios from 'axios'

export const profileApi = {

  update (profileData) {
    return axios.put(`${baseUrl}/account/update-profile`, {
      me: {
        emailStatus: 'change-requested',
        ...profileData
      },
      ...profileData
    })
  },

  deleteData () {
  }
}
